"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkflowContext = void 0;

var _react = _interopRequireDefault(require("react"));

/* eslint import/prefer-default-export: 0 */
var WorkflowContext = /*#__PURE__*/_react.default.createContext({
  description: 'This is the default value for WorkflowContext'
});

exports.WorkflowContext = WorkflowContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/workflow/impl/WorkflowContext.js
// module id = 2182
// module chunks = 25